// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"19":"blog","213":"demo","594":"blog-post","962":"home"}[chunkId] + "." + {"19":"7834884f","213":"f6ce0f18","594":"2d7fe2f8","962":"4cdc9c0f"}[chunkId] + ".js";
};